import React, { useEffect, useState } from "react";
import "../style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import logo from "../img/logo.png";
import SideNav from "components/SideNav";
import { collection, query, where, getDocs, arrayUnion } from "firebase/firestore";
import { db } from "../firebase/firebase";
import background_image from "../img/take-notes.jpg";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { doc, updateDoc, deleteDoc } from "firebase/firestore";

export default function Settings() {
  const [groups, setGroups] = useState(<></>);

  const loadPermission = async (urlVar) => {
    const q = query(collection(db, "users"), where("__name__", "==", urlVar));

    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      if (doc.data().isAdmin) {
        getData(doc.data().permission_groups);
      } else {
        window.location.replace("/");
      }
    });
  };

  useEffect(() => {
    const getUser = async () => {
      const auth = await getAuth();

      onAuthStateChanged(auth, (user) => {
        if (user) {
          loadPermission(user.uid);
        } else {
          window.location.replace("/");
        }
      });
    };
    getUser();
  }, []);

  const getData = async (permissions) => {
    var q = query(collection(db, "permissions"));

    const querySnapshot = await getDocs(q);
    const elements = [<></>];

    querySnapshot.forEach((doc) => {
      elements.push(
        <>
          <div style={{ textAlign: "center", marginBottom: 50 }}>
            {JSON.stringify(doc?.data()?.group)}
          </div>
        </>
      );
    });

    setGroups(elements);
  };

  function addGroup(plan) {
    onAddGroup(plan);
  }

  const onAddGroup = async (plan) => {
    try {
      const groups = doc(db, "permissions", "permission_group");

      await updateDoc(groups, {
        group: arrayUnion(name),
      });
    } catch (error) {
      alert(error);
    }

    setName("");
    getData();

  
  };

  useEffect(() => {}, []);
  const [name, setName] = useState("");

  const Content = () => (
    <section className="home-section">
      <div className="text">Einstellungen</div>

      <section
        style={{ backgroundColor: "#ecf5ff" }}
        className="plan-data"
        id="plan-data"
      >
        <div className="container">
          <h2 id="plan-title">{"Gruppen:"}</h2>
          <>{groups}</>
          <h2 id="plan-title">{"Berechtigungs-Gruppe erstellen"}</h2>
          <form className="contact-form">
            <p>Name:</p>

            <input
              type="search"
              className="plan-name"
              placeholder="Name"
              id="plan-name"
              value={name}
              onChange={(evt) => {
                setName(evt.target.value);
              }}
            />
          </form>
        </div>

        <div className="form-button">
          <div style={{ display: "flex" }}>
            <button
              onClick={() => {
                addGroup();
              }}
              className="btn submit-form"
              type="submit"
            >
              Hinzufügen
            </button>
            <div style={{ width: 10 }}></div>

            <button
              onClick={() => {}}
              className="btn btn-gray submit-form"
              type="submit"
            >
              Abbrechen
            </button>
            <div style={{ width: 10 }}></div>
          </div>

          {/* 
          <button
            onClick={() => {}}
            className="btn btn-red submit-form"
            type="submit"
          >
            Löschen
          </button> */}
        </div>
      </section>
    </section>
  );

  const selPage = "settings";

  return (
    <>
      <head>
        <link
          href="https://unpkg.com/boxicons@2.0.7/css/boxicons.min.css"
          rel="stylesheet"
        />
      </head>
      {SideNav({
        Content,
        selPage,
      })}
    </>
  );
}
